import { useSelector } from "@jti/store";
import { replaceStringPlaceholder } from "@jti/ui";
const useStringPlaceholder = () => {
    const { name, points: { balance }, rewards, } = useSelector((state) => state.loyaltyCore);
    const placeholdersConfig = [
        {
            placeholder: "userName",
            value: name,
        },
        {
            placeholder: "userPoints",
            value: balance,
        },
        {
            placeholder: "rewardsNumber",
            value: rewards,
        },
    ];
    return (text, withStyle) => replaceStringPlaceholder(text, placeholdersConfig, withStyle);
};
export default useStringPlaceholder;
//# sourceMappingURL=useStringPlaceholder.js.map